import React, { lazy } from 'react';
import './Report.sass';
import i18n from '../../../../../i18n';
import DataArray from '../../../../../base/config/DataArray';
const Title = lazy(() => import('../../../../component/title/Title'));

function Report() {
    var dataArray = DataArray.reports;

    return (
        <div className="ReportArea">
            <div className="ReportTitleArea">
                <Title size="Big" type="Secundary" text={i18n.t('You will never be alone. You are in a good company.')} />
            </div>
            <div>
                {dataArray.map((report, key) => {
                    return (
                        <div className="ReportContentArea" key={key}>
                            <div className="ReportContentTitle">
                                <Title size="Big" type="Tertiary" text={report.number} />
                                <div className="ReportContentLine" />
                            </div>
                            <div className="ReportContentText">
                                <Title size="Small" type="SecundaryRegular" text={report.text} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Report;
